import { type MCPServerInfo } from '../../types';

const WorkatoServer: MCPServerInfo = {
  serverId: 'WORKATO',
  name: 'Workato',
  slug: 'workato',
  description:
    "Execute enterprise automation recipes, manage integrations between business applications, monitor workflow performance, and create complex data transformations through Workato's enterprise automation platform.",
  source: {
    sourceType: 'REMOTE_URL',
    mcpServerUrl: 'https://mcp.workato.com/sse',
    transport: 'SSE'
  },
  authenticationType: 'OAUTH',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {}
  }
};

export default WorkatoServer;
